<template>
    <div class="WebViewList pa-3">
        <v-layout>
            <v-text-field
                outlined
                dense
                hide-details
                v-model="searchKey"
                class="mb-3"
                :label="this.$f.tc('search')"
            ></v-text-field>
            <v-select
                outlined
                dense
                hide-details
                clearable
                :label="this.$f.tc('entityType')"
                class="ml-3"
                :items="typeList"
                v-model="searchType"
            ></v-select>
        </v-layout>
        <FCIDataTable :items="filterItems" :headers="headers">
            <template v-slot:action="props">
                <v-btn icon class="mr-3">
                    <v-icon @click="editItem(props.item, props.index)">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon @click="deleteItem(props.item, props.index)">mdi-delete</v-icon>
                </v-btn>
            </template>
        </FCIDataTable>
        <v-btn color="primary" class="mt-3" @click="addItem">{{ $f.tc('add') }}</v-btn>
        <WebViewEditor ref="ItemEditor"></WebViewEditor>
    </div>
</template>

<script>
import ListViewMixin from '@/modules/fptai/mixins/ListViewMixin'
import { WebViewService } from '@/services/bot.service'
import WebViewEditor from '@/views/Scenario/Setting/WebViewEditor'
import { WebViewType } from '@/utils/const'

export default {
    name: 'WebViewList',
    components: { WebViewEditor },
    mixins: [ListViewMixin],
    data () {
        let typeList = []
        for (let i in WebViewType) {
            typeList.push({
                text: WebViewType[i],
                value: WebViewType[i]
            })
        }
        return {
            typeList,
            searchType: '',
            updateGraphAfterRefresh: false
        }
    },
    computed: {
        headers () {
            return [
                {
                    text: this.$f.tc('name'),
                    value: 'name'
                },
                {
                    text: this.$f.tc('action'),
                    value: 'action',
                    type: 'custom'
                }
            ]
        },
        filterItems () {
            let items = this.items
            let searchKey = this.$ut.noAccent(this.searchKey)
            if (searchKey) {
                items = items.filter(item => this.$ut.noAccent(item.name).includes(searchKey))
            }
            if (this.searchType) {
                items = items.filter(item => item.config.type === this.searchType)
            }
            return items
        }
    },
    methods: {
        refresh () {
            WebViewService.search(this.$route.params.botCode).then(result => {
                this.items = result.data
                this.items.forEach(item => {
                    item.config = JSON.parse(item.config)
                })
                this.$store.dispatch(this.$at.scenario.WEB_VIEW_LIST, this.items).then(() => {
                    if (this.updateGraphAfterRefresh) {
                        this.updateGraphAfterRefresh = false
                        // update graph data
                        this.$store.dispatch(this.$at.scenario.SHOULD_UPDATE_GRAPH)
                        // update active step
                        this.$nextTick(() => {
                            this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                                activeGraphCardNodeId: this.$store.state.scenario.activeGraphCardNodeId,
                                activeGraphStepNodeId: this.$store.state.scenario.activeGraphStepNodeId
                            })
                        })
                    }
                })
            })
        },
        addItem () {
            this.$refs.ItemEditor.open(null).then(webview => {
                WebViewService.create(this.$route.params.botCode, {
                    name: webview.name,
                    config: JSON.stringify(webview.config)
                }).then(() => {
                    this.refresh()
                })
            })
        },
        editItem (item) {
            this.$refs.ItemEditor.open(item).then(webview => {
                if (
                    webview.name !== item.name ||
                    !this.$ut.cov(webview.config, item.config)
                ) {
                    WebViewService.update(this.$route.params.botCode, item.code, {
                        name: webview.name,
                        config: JSON.stringify(webview.config)
                    }).then(() => {
                        if (
                            webview.config.type === WebViewType.CUSTOM &&
                            item.config.type === webview.config.type &&
                            webview.config.call_back_step !== item.config.call_back_step
                        ) {
                            this.updateGraphAfterRefresh = true
                        }
                        this.refresh()
                    })
                }
            })
        },
        onDeleteItem (item) {
            WebViewService.delete(this.$route.params.botCode, item.code).then(() => {
                this.refresh()
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
